// extracted by mini-css-extract-plugin
export default {"HeroSection":"Notfound_HeroSection__T3UDq"};